//@ts-nocheck

export const verifyEnum = (value, enums) => {
  if (!enums.includes(value))
    throw `invalid enum type: ${value}. Expected on of ${enums.join(" | ")}`;
  return value;
};

export const randHashString = (len) => {
  return "x".repeat(len).replace(/[xy]/g, (c) => {
    let r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const randomNumber = (min, max) => min + Math.random() * (max - min);

export const randomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const removeKey = (obj, key) => {
  let newObj = Object.assign({}, obj);
  delete newObj[key];
  return newObj;
};

export const removeKeys = (obj, keys) => {
  let newObj = Object.assign({}, obj);
  for (let key of keys) {
    delete newObj[key];
  }
  return newObj;
};

export const delay = (millis) => new Promise((res) => setTimeout(res, millis));

export const serverDate = async (gmt_offset = 5) => {
  try {
    const response = await fetch("https://www.google.com", { method: "HEAD" });
    const dateString = response.headers.get("Date");
    if (!dateString) return new Date();
    const millis = new Date(dateString).getTime() + gmt_offset * 3600000;
    return new Date(millis);
  } catch (error) {
    return new Date();
  }
};

export const getProxyUrl = (url) =>
  "https://pacific-gorge-86477.herokuapp.com/" + url;

export const capitalize = (str) => str[0].toUpperCase() + str.slice(1);
